(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_db46ec6"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.js-ai-press-download');
    if (!trigger) return;

    var url = trigger.getAttribute('href');
    if (!url) return;

    // Verhindert, dass der Browser die Datei (z.B. ein Bild) in einem
    // neuen Tab öffnet, anstatt sie herunterzuladen.
    event.preventDefault();

    var filename = trigger.getAttribute('data-filename') || 'download';
    var extensionMatch = url.split('?')[0].match(/\.([a-zA-Z0-9]+)$/);
    if (extensionMatch && filename.indexOf('.') === -1) {
      filename += '.' + extensionMatch[1];
    }

    fetch(url, { mode: 'cors' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Netzwerkantwort war nicht ok');
        }
        return response.blob();
      })
      .then(function (blob) {
        var blobUrl = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      })
      .catch(function () {
        // Fallback, falls das Laden per fetch fehlschlägt (z.B. CORS):
        // Datei in neuem Tab öffnen, damit der Download nicht komplett fehlschlägt.
        window.open(url, '_blank');
      });
  });
  } catch(e) { console.error(e); }
})();

})();
